export default `float de(vec3 p) {
    float scale = 7.;
    float thickness = 0.05;
    float bias = 0.1;

    p *= scale;
    return (abs(dot(sin(p*.5), cos(p.zxy * 1.23)) - bias) / scale - thickness)*0.55;
  }`